import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/css/app.css';
import './assets/css/Icons.css';


ReactDOM.render(
  <App />,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/